import {
	Box,
	Select,
	Stack,
	Typography,
	MenuItem,
	Grid,
	TextField,
	FormControl,
	InputLabel,
} from "@mui/material";
import React, { useState, useEffect } from "react";

const MilestoneModel = ({ formik }) => {
	const [numMilestones, setNumMilestones] = useState(1);
	const [deliveryTime, setDeliveryTime] = useState(1);

	const handleMilestoneChange = (event) => {
		const value = parseInt(event.target.value, 10);
		setNumMilestones(value);

		// Initialize percentages for new milestones
		const newMilestones = Array(value).fill(0);
		for (let i = 0; i < value; i++) {
			newMilestones[i] = formik.values.milestones[i];
		}
		formik.setFieldValue("milestones", newMilestones);
	};

	const handlePercentageChange = (index, value) => {
		const newMilestones = [...formik.values.milestones];
		newMilestones[index] = parseFloat(value) || 0;
		formik.setFieldValue("milestones", newMilestones);
	};

	const renderMilestoneInputs = () => {
		const inputs = [];
		for (let i = 0; i < numMilestones; i++) {
			inputs.push(
				<Grid item xs={12} sm={6} key={i}>
					<Box
						sx={{
							p: 2,
							border: "1px solid #e0e0e0",
							borderRadius: 1,
						}}
					>
						<Typography variant="subtitle1" gutterBottom>
							Milestone {i + 1}
						</Typography>
						<TextField
							fullWidth
							type="number"
							step="0.01"
							placeholder="Enter percentage %"
							value={formik.values.milestones[i]}
							onChange={(e) =>
								handlePercentageChange(i, e.target.value)
							}
							InputProps={{
								inputProps: {
									min: 0,
									max: 100,
								},
							}}
							helperText="Enter percentage (0-100)"
						/>
					</Box>
				</Grid>
			);
		}
		return inputs;
	};

	const validateMilestonesSum = () => {
		const sum = formik.values.milestones.reduce(
			(acc, val) => acc + (parseFloat(val) || 0),
			0
		);
		return sum === 100;
	};

	const milestonesSumError = !validateMilestonesSum();

	useEffect(() => {
		// Initialize milestones in formik values
		formik.setFieldValue("milestones", Array(numMilestones).fill(0));
	}, [numMilestones]);

	useEffect(() => {
		formik.setFieldValue("paymentPlan", "MilestoneWise");
	}, []);

	return (
		<Box>
			<Typography sx={{ margin: "10px 0px" }}>
				Payment Plan
				<span style={{ color: "red", marginLeft: "5px" }}>*</span>
			</Typography>
			<Stack direction={{ xs: "column", sm: "row" }} spacing={3} mb={4}>
				<FormControl
					sx={{
						minWidth: 200,
					}}
				>
					<Stack direction={"row"} alignItems={"center"}>
						{" "}
						<label style={{ margin: "10px 0px" }}>
							No of Milestones :
							<span style={{ color: "red", marginLeft: "5px" }}>
								*
							</span>
						</label>
						<Select
							sx={{
								minWidth: 100,
								ml: 2,
							}}
							value={numMilestones}
							onChange={handleMilestoneChange}
						>
							<MenuItem value={1}>1</MenuItem>
							<MenuItem value={2}>2</MenuItem>
							<MenuItem value={3}>3</MenuItem>
							<MenuItem value={4}>4</MenuItem>
						</Select>
					</Stack>
				</FormControl>

				<FormControl sx={{ minWidth: 200 }}>
					<Stack direction={"row"} alignItems={"center"}>
						<label style={{ margin: "10px 0px" }}>
							Delivery Time :
							<span style={{ color: "red", marginLeft: "5px" }}>
								*
							</span>
						</label>
						<Select
							sx={{
								minWidth: 100,
								ml: 2,
							}}
							value={deliveryTime}
							onChange={(e) => setDeliveryTime(e.target.value)}
						>
							<MenuItem value={1}>1 month</MenuItem>
							<MenuItem value={2}>2 months</MenuItem>
							<MenuItem value={3}>3 months</MenuItem>
							<MenuItem value={4}>4 months</MenuItem>
						</Select>
					</Stack>
				</FormControl>
			</Stack>

			<Grid container spacing={3}>
				{renderMilestoneInputs()}
			</Grid>
			{milestonesSumError && (
				<Typography variant="caption" color="error">
					The sum of all milestones must be 100%
				</Typography>
			)}
		</Box>
	);
};

export default MilestoneModel;
